import styled from 'styled-components';
import { breakpoint } from 'styles/globals';
import Heading from 'styles/typography/Heading';

const Title = styled(Heading)`
  margin: 24px 16px 40px 16px;
  
  @media (${breakpoint.mdMin}) {
    margin: 32px 0 48px 0;
  }

  @media (${breakpoint.lgMin}) {
    margin: 48px 0 64px 0;
  }
`;

export default Title;
